import { render, staticRenderFns } from "./ScreenMorfologicaDopplerComCervical.vue?vue&type=template&id=144eb441&scoped=true&"
import script from "./ScreenMorfologicaDopplerComCervical.vue?vue&type=script&lang=js&"
export * from "./ScreenMorfologicaDopplerComCervical.vue?vue&type=script&lang=js&"
import style0 from "./ScreenMorfologicaDopplerComCervical.vue?vue&type=style&index=0&id=144eb441&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144eb441",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
